import {
    Input,
    OnInit,
    Component,
    ChangeDetectorRef,
    ChangeDetectionStrategy} from '@angular/core';
import { VehicleItem } from '../../../api/models/vehicle-item';
import { NameCasePipe } from '../../pipes/name-case.pipe';

@Component({
    selector: 'app-vehicle-card',
    templateUrl: './vehicle-card.component.html',
    styleUrls: ['./vehicle-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleCardComponent implements OnInit {

    @Input() Index: any = 0;
    @Input() Item: VehicleItem = null;
    @Input() isPrequalified: boolean = false;

    get vehicleName (): string {
        var template: string[] = [];
        var nameCaser = new NameCasePipe();
        template.push(this.Item.BasicInfo.Year.toString());
        template.push(nameCaser.transform(this.Item.BasicInfo.Make));
        template.push(nameCaser.transform(this.Item.BasicInfo.Model));
        template.push(nameCaser.transform(this.Item.BasicInfo.Trim));
        return template.join(' ');
    }

    get isVehiclePrequalified (): boolean {
        return this.isPrequalified && this.Item && this.Item.PaymentInfo && this.Item.PaymentInfo.IsPreQualified;
    }

    constructor(private cd: ChangeDetectorRef) {}

    ngOnInit() { }

    urlLink () {
        const _url = `${this.Item.BasicInfo.Condition}-
            ${this.Item.BasicInfo.Year}-
            ${this.Item.BasicInfo.Make}-
            ${this.Item.BasicInfo.Model}-
            ${this.Item.DealerInfo.DealerCity}-
            ${this.Item.DealerInfo.DealerState}-
            ${this.Item.InventoryId}
        `;
        return _url.replace(/\s+/g, '');
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/vehicle-card/vehicle-card.component.ts